var params = new URLSearchParams(document.location.search);
  var bundlename = params.get("nome")
  var aggettivo = params.get("aggettivo"); 
  var colore = params.get("colore");
  var obiettivo = params.get("obiettivo");

  document.getElementById("bundle-name").innerHTML = bundlename;
  document.getElementById("aggettivoli").value = aggettivo;
  document.getElementById("coloreoli").value = colore;
  document.getElementById("obiettivoli").value = obiettivo;
  document.getElementById(aggettivo).style.display = "block";
  document.getElementById(colore).style.display = "block";
  document.getElementById(obiettivo).style.display = "block";